export default function () {
  const sortButton = document.querySelector('.FilterBar__Sort')
  const sortOptions = document.querySelector('.FilterBar__SortOptions')

  if (sortButton && sortOptions) {
    sortButton.addEventListener('click', toggleSortOptions)
  }

  function toggleSortOptions() {
    sortOptions?.classList.toggle('FilterBar__SortOptions--is-visible')
  }
}
